import { makeAutoObservable } from 'mobx';
import Video from './Video';
import Analyse from './Analyse';
import guid from '../../../../utils/guid';
import { Person } from '../../../../models';
import { SORT_DATA_TYPES, sort } from '../../../../utils/array';

export default class VideoAnalyse {
  id;
  date_created;
  title;
  analyses = [];
  sharedWith = [];
  sharedFrom = null;
  video;

  constructor({
    id = guid(),
    date_created = new Date(),
    title = '',
    analyses,
    sharedWith,
    sharedFrom,
    video
  }) {
    this.id = id;
    this.date_created = date_created;
    this.title = title;
    this.analyses =
      analyses && analyses.length ? analyses.map(a => new Analyse(a)) : [];
    this.sharedWith =
      sharedWith && sharedWith.length ? sharedWith.map(p => new Person(p)) : [];
    this.sharedFrom = sharedFrom ? new Person(sharedFrom) : null;
    this.video = video ? new Video(video) : Video.getDummyVideo();

    this.analyses = sort(this.analyses, {
      keys: [
        {
          key: 'date_created',
          dataType: SORT_DATA_TYPES.DATE_STRING,
          desc: true
        }
      ]
    });

    makeAutoObservable(this);
  }

  /*set localFile(file) {
    this._localFile = file;
  }

  get localFile() {
    if (this._localFile) {
      window.URL.revokeObjectURL(this._localFile);
      return window.URL.createObjectURL(this._localFile);
    }
  }*/
}
